<template>
  <div class="color-picker-wrap">
    <a-popconfirm
      placement="bottom"
      trigger="click"
      overlayClassName="color-picker-popover"
      okText="Confirm"
      cancelText="Reset"
      @confirm="confirm"
      @cancel="reset"
    >
      <template slot="icon"></template>
      <template slot="title">
        <chrome-picker :value="curColor" @input="changeColor" />
      </template>
      <a-input
        disabled
        :value="color"
        placeholder="input search text"
        size="large"
      >
        <div
          slot="addonAfter"
          class="color-block"
          :style="{ backgroundColor: color }"
        ></div>
      </a-input>
    </a-popconfirm>

    <!-- {{ color }} -->
  </div>
</template>

<script>
import { Chrome } from "vue-color";
export default {
  name: "ColorPicker",
  components: {
    "chrome-picker": Chrome,
  },
  inject: ["customThemeFn", "originalTheme", "allocateTheme"],
  props: {
    color: {
      type: [String, Number],
      default: "",
    },
    section: {
      type: String,
      default: "",
    },
    field: {
      type: String,
      default: "",
    },
  },
  computed: {
    customTheme: {
      get() {
        return this.customThemeFn();
      },
      set(val) {},
    },
  },
  data() {
    return {
      curColor: "",
    };
  },
  watch: {
    color: {
      handler(val) {
        // this.curColor = {
        //   hex8: val,
        // };
        this.curColor = val;
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    changeColor(val) {
      // console.log(val);
      this.curColor = val;
    },
    confirm() {
      // console.log(this.curColor);
      this.$emit("update:color", this.curColor.hex8);
      this.$set(this.customTheme[this.section], this.field, this.curColor.hex8);

      this.allocateTheme(this.customTheme);
    },
    reset() {
      // console.log("reset");
    },
  },
};
</script>


<style lang="scss" scoped="scoped">
.color-block {
  border-radius: 5px;
  width: 40px;
  height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/ColorPicker.vue